import { gql } from '@apollo/client'

export const FETCH_POTENTIALLY_RECURRING_SLOTS = gql`
  query ehrPotentiallyRecurringSlots(
    $appointmentKind: EhrAppointmentKind!
    $providerKind: EhrAppointmentProviderKind!
    $providerId: ID!
    $timeZone: String
  ) {
    ehrPotentiallyRecurringSlots(
      appointmentKind: $appointmentKind
      providerKind: $providerKind
      providerId: $providerId
      timeZone: $timeZone
    ) {
      weekly
      biWeekly
      monthly
    }
  }
`
